module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-40.315d1fc6.png";